"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteProductLoader = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteProductStore_1 = require("./QuoteProductStore");
var c = (0, BemBuilder_1.default)("quote-product-loader");
var QuoteProductLoader = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var state = _a.state, component = _a.component;
    return [QuoteProductStore_1.QuoteProductStatus.Loading, QuoteProductStore_1.QuoteProductStatus.Available].includes(state) ? (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("component"), (_b = {},
                _b[c("component", "hidden")] = state === QuoteProductStore_1.QuoteProductStatus.Loading,
                _b)) }, component),
        state === QuoteProductStore_1.QuoteProductStatus.Loading && react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: c("ghost") }))) : null;
});
exports.QuoteProductLoader = QuoteProductLoader;
